import processJSON from '@/lib/processJSON';

const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_TAX = ROOT_API + 'get_tax.php';
const GET_SPECIES_NAME_SHORT = ROOT_API + 'get_species_name_short.php';

import address from './address';

export default {
  namespaced: true,

  modules: {
    address
  },

  state: {
    selectedTax: [],

    selectedTaxIsLoading: false,

    info_species_name_short: [],

    changingSpeciesPriorityInProcess: false,
    deletingSpeciesInProgress: false,
  },
  mutations: {
    setSelectedTax(state, payload) {
      state['selectedTax'] = payload;
    },

    setSpeciesNameShort(state, payload) {
      state['info_species_name_short'] = payload;
    },

    clearTax(state, payload) {
      state['selectedTax'] = [];
      state['info_species_name_short'] = [];
    },

    setChangingSpeciesPriorityInProcess(state, payload) {
      state['changingSpeciesPriorityInProcess'] = payload;
    },
    setDeletingSpeciesInProgress(state, payload) {
      state['deletingSpeciesInProgress'] = payload;
    }
  },
  getters: {
    getTaxOZU(state) {
      return state.selectedTax[0]?.ozu;
    },
    getLandTypes(state, getters) {
      const typesUnforest = [
					{ id: '1', text: 'КУЛЬТУРЫ НЕСОМКН.' },
					{ id: '2', text: 'ПИТОМНИК, ПЛАНТАЦИЯ' },
					{ id: '3', text: 'РЕДИНА ЕСТЕСТВЕННАЯ' },
					{ id: '4', text: 'ГАРЬ' },
					{ id: '5', text: 'НАС. ПОГИБШЕЕ' },
					{ id: '6', text: 'ВЫРУБКА' },
					{ id: '7', text: 'ПРОГАЛИНА' },
				]
				const typesNonforest = [
					{ id: '1', text: 'ПАШНИ' },
					{ id: '2', text: 'СЕНОКОСЫ' },
					{ id: '3', text: 'ПАСТБИЩА' },
					{ id: '4', text: 'ВОДЫ' },
					{ id: '5', text: 'САДЫ, ТУТОВИКИ, ЯГОДНИКИ' },
					{ id: '6', text: 'ДОРОГИ, ПРОСЕКИ' },
					{ id: '7', text: 'УСАДЬБЫ' },
					{ id: '8', text: 'БОЛОТА' },
					{ id: '9', text: 'ПЕСКИ' },
					{ id: '10', text: 'ЛЕДНИКИ' },
					{ id: '11', text: 'ПРОЧИЕ ЗЕМЛИ' },
				]
        return {typesUnforest, typesNonforest}
    },
    isDeadForest(state, getters) {
      return state.selectedTax.length && state.selectedTax[0].unforested_land_id === '5' ? true : false;
    },
    isBurntForest(state, getters) {
      return state.selectedTax.length && state.selectedTax[0].unforested_land_id === '4' ? true : false;
    },
    isDeadOrBurntForest(state, getters) {
      return getters.isDeadForest || getters.isBurntForest;
    },

    isDeadSuhostoi(state, getters) {
      return getters.isDeadForest && state.selectedTax[0].is_new_dead === 't';
    },  

    layerList(state, getters) {
      if (state.selectedTax.length === 1 && !state.selectedTax[0].layer_id) {
        return [];
      }

      const result = [];
      for (const item of state.selectedTax) {
        if (!result.find(row => row.layer === item.layer)) {
          result.push(item);
        }
      }
      return result;
    },
    layerSpeciesList: state => layer => {
      return state.selectedTax.filter(item => {
        return item.layer === layer.layer && item.tax_species_id;
      });
      // if (state.selectedTax.length === 1 && !state.selectedTax[0].tax_species_id) {
      //   return [];
      // }

      // const result = [];
      // for (const item of state.selectedTax) {
      //   if (item.layer === layer.layer) {
      //     result.push(item);
      //   }
      // }
      // return result;
    },
  },
  actions: {
    getTax(context, payload) {
      const { commit } = context;

      const tax_id = payload;

      const form = new FormData();
      form.append('tax_id', tax_id);

      return fetch(GET_TAX, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setSelectedTax', res);
      })
      .catch(err => console.log(err));
    },

    updateTax(context, payload) {
      const { state, dispatch } = context;
      return dispatch('getTax', state.selectedTax[0].tax_id);
    },

    createTax(context, payload) {
      const { state } = context;

      const locality_id = state.address.selectedArea.id;
      const section = state.address.selectedSection;

      const json_obj = [
        {
          'i': {
            'tab': [
              {
                'tab_name': 'info_tax',
                'f_v': {
                  'locality_id': locality_id,
                  'section': section,
                }
              }
            ]
          }
        }
      ];
      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    getSpeciesNameShort(context, payload) {
      const { commit } = context;

      const species = payload;

      // console.log('species', species);

      const form = new FormData();
      form.append('species_id', species.id);

      fetch(GET_SPECIES_NAME_SHORT, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setSpeciesNameShort', res);
      })
      .catch(err => console.log(err));
    },

    saveTaxGeneral(context, payload) {
      const { state } = context;

      const valueList = payload;

      const f_v_rest = {};
      for (const item of valueList) {
        f_v_rest[item.field] = item.value;
      }

      const json_obj = [
        {
          'u': [
            {
              'tab_name': 'info_tax',
              'f_v': {
                'id': state.selectedTax[0].tax_id,
                ...f_v_rest
              }
            }
          ]
        }
      ];
      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    /* LAYERS */
    addLayer(context, payload) {
      const { state, getters } = context;
      const layer = payload;
      let layer_num = null;
      if (layer.type === 4) {
        layer_num = 11
      } else {
        layer_num = getters.layerList.length + 1;
      }
      const json_obj = [
        {
          'i': {
            'tab': [
              {
                'tab_name': 'info_tax_layer',
                'f_v': {
                  'parent_id': state.selectedTax[0].tax_id,
                  'layer': layer_num,
                  'composition': layer.composition,
                  'fullness': layer.fullness,
                  'stock': layer.stock,
                  // 'stock_dead': layer.stock_dead,
                  'age_class': layer.age_class
                }
              }
            ]
          }
        }
      ];

      const json_str = JSON.stringify(json_obj);
      console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    editLayer(context, payload) {
      const layer = payload;

      const json_obj = [
        {
          'u': [
            {
              'tab_name': 'info_tax_layer',
              'f_v': {
                'id':layer.layer_id,
                'composition': layer.composition,
                'fullness': layer.fullness,
                'stock': layer.stock,
                // 'stock_dead': layer.stock_dead,
                'age_class': layer.age_class
              }
            }
          ]
        }
      ];
      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    removeLayer(context, payload) {
      const { state, getters } = context;

      const layer = payload;

      const layer_num = layer.layer;
      const updateSection = [];


      for (const l of getters.layerList) {
        if (+l.layer <= + layer_num) {
          continue;
        }

        const temp = {
          'tab_name': 'info_tax_layer',
          'f_v': {
            'id': l.layer_id,
            'layer': +(l.layer - 1)
          }   
        };
        updateSection.push(temp);
      }

      const json_obj = [
        {
          'u': updateSection
        },
        {
          'd': [
            {
              'tab_name': 'info_tax_layer',
              'id': layer.layer_id
            }
          ]
        }
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },
    removeAllLayers(context, payload) {
      const { getters } = context;

      const deleteSection = [];
      for (const layer of getters.layerList) {
        const temp = {
          'tab_name': 'info_tax_layer',
          'id': layer.layer_id
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          'd': deleteSection
        }
      ];
      const json_str = JSON.stringify(json_obj);
      console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    /* SPECIES */
    addSpecies(context, payload) {
      const { getters } = context;

      const layer = payload.layer;
      const species = payload.species;

      // console.log(JSON.stringify(layer, null, 2));
      // console.log(JSON.stringify(species, null, 2));
      // return;

      // const is_main = getters.layerSpeciesList(layer).length ? false : true;


      const json_obj = [
        {
          'i': {
            'tab': [
              {
                'tab_name': 'info_tax_layer_species',
                'f_v': {
                  'parent_id': layer.layer_id,
                  'species_id': species.species.id,
                  'name': species.species.name,
                  'name_short': species.name_short,
                  'gen': species.gen,
                  'coeff': species.coeff === '+' ? '0' : species.coeff,
                  'age': species.age,
                  'h': species.h,
                  'd': species.d,

                  'species_num': getters.layerSpeciesList(layer).length + 1,
                  // 'is_main': is_main,
                  // 'is_extra': species.is_extra,
                }
              }
            ]
          }
        }
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    editSpecies(context, payload) {
      const species = payload;

      const json_obj = [
        {
          'u': [
            {
              'tab_name': 'info_tax_layer_species',
              'f_v': {
                'id':species.id,
                'species_id': species.species.id,
                'name': species.species.name,
                'name_short': species.name_short,
                'gen': species.gen,
                'coeff': species.coeff === '+' ? '0' : species.coeff,
                'age': species.age,
                'h': species.h,
                'd': species.d
              }
            }
          ]
        }
      ];
      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    removeSpecies(context, species) {
      const { getters, commit } = context;

      const speciesList = getters.layerSpeciesList(species);

      const updateSection = [];
      for (const speciesItem of speciesList) {
        if (+speciesItem.species_num > +species.species_num) {
          const temp = {
            'tab_name': 'info_tax_layer_species',
            'f_v': {
              'id': speciesItem.tax_species_id,
              'species_num': +speciesItem.species_num - 1
            }
          };
          updateSection.push(temp);
        }
      }

      const json_obj = [
        {
          'u': updateSection
        },
        {
          'd': [
            {
              'tab_name': 'info_tax_layer_species',
              'id': species.tax_species_id
            }
          ]
        }
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      commit('setDeletingSpeciesInProgress', true);
      return processJSON(json_str).finally(() => {
        commit('setDeletingSpeciesInProgress', false);
      });
    },

    upSpeciesNum(context, species) {
      const { state, getters, commit } = context;

      if (state.changingSpeciesPriorityInProcess) {
        return Promise.reject(new Error('ALREADY_PROCESSING'));
      }

      if (species.species_num === '1') {
        return Promise.reject(new Error('FIRST_SPECIES_ERROR'));
      }

      const speciesList = getters.layerSpeciesList(species);
      const speciesPrev = speciesList.find(s => +s.species_num === +species.species_num - 1);

      const json_obj = [
        {
          'u': [
            {
              'tab_name': 'info_tax_layer_species',
              'f_v': {
                'id': species.tax_species_id,
                'species_num': speciesPrev.species_num,
              }
            },
            {
              'tab_name': 'info_tax_layer_species',
              'f_v': {
                'id': speciesPrev.tax_species_id,
                'species_num': species.species_num,
              }
            }
          ]
        }
      ];

      const json_str = JSON.stringify(json_obj);
      //console.log(json_str);
      //return;

      commit('setChangingSpeciesPriorityInProcess', true);

      return processJSON(json_str).then(res => {

      }).catch(err => {
        console.log('123')
        throw err;
      }).finally(() => {
        console.log('456')
        commit('setChangingSpeciesPriorityInProcess', false);
      });
    },
    downSpeciesNum(context, species) {
      const { state, getters, commit } = context;

      if (state.changingSpeciesPriorityInProcess) {
        return Promise.reject(new Error('ALREADY_PROCESSING'));
      }

      const speciesList = getters.layerSpeciesList(species);

      if (+species.species_num === speciesList.length) {
        return Promise.reject(new Error('LAST_SPECIES_ERROR'));
      }

      const speciesNext = speciesList.find(s => +s.species_num === +species.species_num + 1);

      const json_obj = [
        {
          'u': [
            {
              'tab_name': 'info_tax_layer_species',
              'f_v': {
                'id': species.tax_species_id,
                'species_num': speciesNext.species_num,
              }
            },
            {
              'tab_name': 'info_tax_layer_species',
              'f_v': {
                'id': speciesNext.tax_species_id,
                'species_num': species.species_num,
              }
            }
          ]
        }
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      commit('setChangingSpeciesPriorityInProcess', true);

      return processJSON(json_str).then(res => {

      }).catch(err => {
        throw err;
      }).finally(() => {
        commit('setChangingSpeciesPriorityInProcess', false);
      });
    },

    changeMain(context, payload) {
      const { getters } = context;

      const species = payload.species;
      const layer = payload.layer;

      // console.log(JSON.stringify(layer, null, 2));
      // console.log(JSON.stringify(species, null, 2));
      // return;

      const updateSection = [];
      for (const s of getters.layerSpeciesList(layer)) {
        if (s.tax_species_id === species.tax_species_id) {
          const temp = {
            'tab_name': 'info_tax_layer_species',
            'f_v': {
              'id': s.tax_species_id,
              'is_main': true
            }   
          };
          updateSection.push(temp);
        } else {
          const temp = {
            'tab_name': 'info_tax_layer_species',
            'f_v': {
              'id': s.tax_species_id,
              'is_main': false
            }   
          };
          updateSection.push(temp);
        }
      }

      const json_obj = [
        {
          'u': updateSection
        }
      ];
      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    }

  }
};